module.exports = __webpack_public_path__ + "img/Feature.bacb3429.png";